import "react-circular-progressbar/dist/styles.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import styled from "styled-components";

import { ArrowLeftColor } from "@components";
import { PATH_HOME } from "@configs";
import { IMemberTier } from "@interfaces";
import { selectAuth, selectMerchant } from "@redux";
import { RenderMeta } from "@utils";
import { useEffect, useState } from "react";
import { assetApi } from "src/API/asset";
import { tierApi } from "src/API/tier";
import { userApi } from "src/API/user";
import { useFullScreen } from "src/Helpers/useFullscreen";

interface IProps {
    avatar: string;
    fullName: string;
    memberTier: IMemberTier | undefined;
    isConfirm?: boolean;
}

// TODO:
// add state 'tier' for render tier logo and tier name
// implement css for in-active

export const ComponentParking = (props: IProps) => {
    //page hook
    const { t } = useTranslation();
    //push route
    const history = useHistory();
    const location = useLocation();
    //redux statex
    const { userInfo } = useSelector(selectAuth);
    const { themes } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);
    const fullHeight = useFullScreen();

    const [currentTierID, setCurrentTierID] = useState(null);
    const [currentTierName, setCurrentTierName] = useState("");
    const [nextTierID, setNextTierID] = useState<string | null>(null);
    const [nextTierName, setNextTierName] = useState("");

    const [currentCarLimit, setCurrentCarLimit] = useState(0);
    const [nextCarLimit, setNextCarLimit] = useState(0);

    useEffect(() => {
        const fetchTierID = async () => {
            try {
                const { tierID, tierName } = await getTierByUserID();
                setCurrentTierID(tierID || "empty-tier");
                setCurrentTierName(tierName);
            } catch (error) {
                console.error("Error fetching tier ID:", error);
            }
        };

        fetchTierID();
    }, [location.key, userInfo?._id]);

    useEffect(() => {
        const fetchTiers = async () => {
            try {
                const { nextTierID, nextTierName } = await getNextTier();
                setNextTierID(nextTierID);
                setNextTierName(nextTierName);

                console.log("currentTierName", currentTierName);
                console.log("nextTierName", nextTierName);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchTiers();
    }, [currentTierID]);

    useEffect(() => {
        const fetchCurrentTierCarlimit = async () => {
            try {
                if (currentTierID) {
                    let res = await assetApi.getAssetGroupsByTier(currentTierID);
                    const data = res.data.data;

                    for (const group of data) {
                        if (group.tags.some((tag: any) => tag.name === "VIP")) {
                            continue;
                        } else {
                            setCurrentCarLimit(group.asset_limit_per_user);
                        }
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchCurrentTierCarlimit();
    }, [currentTierID]);

    useEffect(() => {
        const fetchCurrentTierCarlimit = async () => {
            try {
                if (nextTierID) {
                    let res = await assetApi.getAssetGroupsByTier(nextTierID);
                    const data = res.data.data;
                    for (const group of data) {
                        if (group.tags.some((tag: any) => tag.name === "VIP")) {
                            continue;
                        } else {
                            setNextCarLimit(group.asset_limit_per_user);
                        }
                    }
                } else {
                    console.error("Error fetching data: tier id null");
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchCurrentTierCarlimit();
    }, [nextTierID]);

    const getTierByUserID = async () => {
        try {
            if (userInfo?._id) {
                const response = await userApi.getTierByUserID(userInfo?._id || "");
                const tierID = response.data.data.tier.id;
                const tierName = response.data.data.tier.name;
                const tags = response.data.data.tags;

                return { tierID, tierName, tags };
            } else {
                console.error("Error fetching user tier: id null");
                return { tierID: null, tierName: "" };
            }
        } catch (error) {
            console.error("Error fetching user tier:", error);
            return { tierID: null, tierName: "" };
        }
    };

    const getNextTier = async () => {
        try {
            let response = await tierApi.getTiers();

            const tiers = response.data.data;

            let nextTierID = "";
            let nextTierName = "";
            for (let i = 0; i < tiers.length; i++) {
                if (tiers[i].name === currentTierName && i > 0) {
                    nextTierID = tiers[i - 1].id;
                    nextTierName = tiers[i - 1].name;
                    break;
                }
            }

            return { nextTierID, nextTierName };
        } catch (error) {
            console.error("Error fetching tiers:", error);
            return { nextTierID: null, nextTierName: "" };
        }
    };

    return (
        <>
            <RenderMeta title="BMI FORM" />
            <StyledParking
                style={{ height: fullHeight }}
                themeColor={themes?.themeColor!}
                bgImg="../../images/bg-calculator.svg"
                contentColor={merchant?.luckyDrawDisplaySetting?.textColor!}
                themePageColor="#76C0D9"
            >
                <header>
                    <div className="back-arrow">
                        <ArrowLeftColor
                            onClick={() => history.push(PATH_HOME)}
                            color={merchant?.luckyDrawDisplaySetting?.themeColor}
                        />
                    </div>
                </header>
                <div className="wrapper-parking">
                    <div className="setlayout">
                        <div className="layout-logo-parking">
                            <span>
                                <img src="../../images/future-park/logo-parking.svg" alt="" />
                            </span>
                            <span>
                                <img src="../../images/future-park/logo-futurepark.svg" alt="" />
                            </span>
                        </div>
                        <div className="set-content">
                            <div className="position-tier-parking">
                                <div className="layout-tier-parking">
                                    <div className="title-tier-parking">Benefits for Each Tier</div>
                                </div>
                                <div className="group-tier-parking">
                                    <div className="box-tier-parking">
                                        <div className="img-box-tier-parking">
                                            {(() => {
                                                switch (currentTierName) {
                                                    case "Gold":
                                                        return (
                                                            <img
                                                                src="../../images/ic-crown-gold.png"
                                                                alt="Gold"
                                                            />
                                                        );
                                                    case "Diamond":
                                                        return (
                                                            <img
                                                                src="../../images/ic-diamond-tier.svg"
                                                                alt="Diamond"
                                                            />
                                                        );
                                                    case "Platinum":
                                                        return (
                                                            <img
                                                                src="../../images/tier-platinum.svg"
                                                                alt="Platinum"
                                                            />
                                                        );
                                                    default:
                                                        return null;
                                                }
                                            })()}
                                        </div>
                                        <div className="title-box-tier-parking">
                                            {currentTierName}
                                        </div>
                                        <div className="can-parking-text">
                                            {currentCarLimit} vehicles
                                        </div>
                                    </div>

                                    {nextTierName && (
                                        <div className="box-tier-parking">
                                            <div className="img-box-tier-parking">
                                                {(() => {
                                                    switch (nextTierName) {
                                                        case "Gold":
                                                            return (
                                                                <img
                                                                    src="../../images/ic-crown-gold.png"
                                                                    alt="Gold"
                                                                />
                                                            );
                                                        case "Diamond":
                                                            return (
                                                                <img
                                                                    src="../../images/ic-diamond-tier.svg"
                                                                    alt="Diamond"
                                                                />
                                                            );
                                                        case "Platinum":
                                                            return (
                                                                <img
                                                                    src="../../images/tier-platinum.svg"
                                                                    alt="Platinum"
                                                                />
                                                            );
                                                        default:
                                                            return null;
                                                    }
                                                })()}
                                            </div>
                                            <div className="title-box-tier-parking diamond">
                                                {nextTierName}
                                            </div>
                                            <div className="can-parking-text">
                                                {nextCarLimit} vehicles
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="set-content">
                            <div className="border-line"></div>
                        </div>
                        <div className="content-text-parking">
                            <div className="title-text-parking">Term & Conditions</div>
                            <div className="detail-text-parking">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                                ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                aliquip ex ea commodo consequat. Duis aute irure dolor in
                                reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                                pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                                culpa qui officia deserunt mollit anim id est laborum.
                            </div>
                        </div>
                        <div className="control-btn">
                            <StyledBtnParking
                                onClick={() => history.push("/myparking")}
                                disabled={currentTierName === "Gold"}
                                style={{
                                    backgroundColor:
                                        currentTierName === "Gold" ? "#E1E1E1" : "#CAD51C",
                                }}
                            >
                                + Register vehicle
                            </StyledBtnParking>
                        </div>
                        <div className="layout-banner-parking">
                            <div className="custom-border">
                                <img src="../../images/setborder-parking.svg" alt="" />
                            </div>
                            <img src="../../images/img-parking.png" alt="" />
                            {/* <img src="../../images/set-img-banner.png" alt="" /> */}
                        </div>
                    </div>
                </div>
            </StyledParking>
        </>
    );
};

const StyledBtnParking = styled.button`
    padding: 14.5px 32px;
    border-radius: 12px;
    background-color: #cad51c;
    color: #fff;
    text-align: center;
    border: none;
`;

const StyledParking = styled.div<{
    themeColor: string;
    bgImg: string;
    contentColor: string;
    themePageColor: string;
}>`
    width: 100%;
    margin: 0 auto;
    height: 100vh;
    overflow: scroll;
    background-color: #76c0d9;
    background-position: center top;
    background-repeat: no-repeat;
    background-size: 100%;
    position: relative;
    background-image: url(../../images/future-park/bg-parking.svg);
    background-size: cover;
    background-position: center;
    &:after {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        background-image: url(../../images/future-park/line-bg-parking.svg);
        background-size: cover;
        background-position: center;
        z-index: 1;
    }
    .setlayout {
        position: relative;
        z-index: 2;
    }
    .logo-survey {
        font-size: 32px;
        color: ${(p) => p.themeColor};
        font-weight: 600;
    }
    .back-arrow {
        position: absolute;
        left: 10px;
        display: flex;
        span {
            margin-left: 10px;
            color: ${(props) =>
                props?.themePageColor !== "" ? `${props?.themePageColor}` : "#fff"};
        }
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        .title-group {
            text-align: center;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #000000;
        }
    }
    .wrapper-parking {
        .layout-logo-parking {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 20px;
            margin-bottom: 28px;
        }
        .set-content {
            padding: 0 32px;
        }
        .position-tier-parking {
            padding: 45px 12px;
            border-radius: 8px;
            background: linear-gradient(
                180deg,
                rgba(255, 255, 255, 0.94) 0%,
                rgba(255, 255, 255, 0.56) 100%
            );
            box-shadow: 0px 4px 12px 0px rgba(107, 78, 35, 0.12);
            backdrop-filter: blur(2px);
            margin-bottom: 14px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            .layout-tier-parking {
                position: absolute;
                top: 0;
                left: 50%;
                transform: translateX(-50%);
            }
            .title-tier-parking {
                background: #e4d19e;
                padding: 6px 0;
                font-size: 14px;
                color: #9d7234;
                line-height: 17px;
                font-weight: 600;
                display: inline-block;
                position: relative;
                &:after {
                    content: "";
                    width: 20px;
                    height: 100%;
                    background-image: url(../../images/future-park/img-title-right.svg);
                    background-size: cover;
                    background-repeat: no-repeat;
                    position: absolute;
                    right: -19px;
                    top: 0;
                }
                &:before {
                    content: "";
                    width: 20px;
                    height: 100%;
                    background-image: url(../../images/future-park/img-title-left.svg);
                    background-size: cover;
                    background-repeat: no-repeat;
                    position: absolute;
                    left: -19px;
                    top: 0;
                }
            }
            .group-tier-parking {
                display: flex;
                align-items: center;
                gap: 20px;
                overflow: scroll;
                .box-tier-parking {
                    width: 70px;
                    text-align: center;
                    &:last-child {
                        .img-box-tier-parking {
                            &::after {
                                display: none;
                            }
                        }
                    }
                    .img-box-tier-parking {
                        position: relative;
                        margin-bottom: 4px;
                        &:after {
                            content: "";
                            background-image: url(../../images/future-park/border-tier.svg);
                            width: 100%;
                            height: 1px;
                            background-size: 100%;
                            position: absolute;
                            top: 13px;
                            right: -50px;
                        }

                        img {
                            width: 24px;
                            height: 24px;
                        }
                    }
                    .diamond {
                        color: #8f5542 !important;
                    }
                    .title-box-tier-parking {
                        font-size: 14px;
                        line-height: 17px;
                        font-weight: 600;
                        color: #a2a2a1;
                    }
                    .can-pariking-text {
                        font-size: 12px;
                        line-height: 15px;
                        color: #6b4e23;
                    }
                }
            }
        }
    }

    .border-line {
        border-bottom: 0.5px dashed #fff;
        margin-bottom: 14px;
    }
    .content-text-parking {
        text-align: center;
        margin-bottom: 24px;
        padding: 0 32px;
        .title-text-parking {
            font-size: 16px;
            line-height: 19px;
            color: #000;
            font-weight: 600;
            margin-bottom: 10px;
        }
        .detail-text-parking {
            font-size: 14px;
            line-height: 17px;
            color: #000000;
        }
    }
    .control-btn {
        text-align: center;
        margin-bottom: 12px;
    }
    .layout-banner-parking {
        position: relative;
        .custom-border {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            img {
                width: 100%;
            }
        }
        img {
            width: 100%;
            height: auto;
        }
    }
`;
